import { View, Text, Image, ImageBackground, ScrollView } from 'react-native'
import React, { useEffect } from 'react'
import DropDownPicker from 'react-native-dropdown-picker'
import { useNavigation } from '@react-navigation/native';
import { useState } from 'react';
import { useLayoutEffect } from 'react';
import dr from './../datosReferenciales.json'
import transl from './../translations/transl'
import { useSelector } from 'react-redux';
import AsyncStorage from '@react-native-async-storage/async-storage';
import GlobalStyles from './../style';
import { Dimensions } from 'react-native'

let lang = undefined;

const Tactics = () => {
	const [loaded, setLoaded] = useState(false);

	const navigation = useNavigation();
    useLayoutEffect(() => {
      navigation.setOptions({
          headerShown: true,
          headerTitle: transl('Tactics.tacticas', lang)
      })
    }, []);

	useEffect(() => {
		const readValue = async () => {
		  try {
			const value = await AsyncStorage.getItem('equipos');
			if (value) {
			  const data = JSON.parse(value);
			  const strat = data.others?.inmatchStates?.strategy ?? {
				chasers: 1,
				beaters: 1,
				changes: 1,
				notUsed: 1,
				beaTacOff: 1,
				beaTacDef: 1,
				keepTac: 1,
				seekTac: 1,
			  };
	  
			  // Seteamos todos los estados de una
			  setValue2(strat.chasers);
			  setValue3(strat.beaters);
			  setValue4(strat.changes);
			  setValue5(strat.notUsed);
			  setValue6(strat.beaTacOff);
			  setValue7(strat.beaTacDef);
			  setValue8(strat.keepTac);
			  setValue9(strat.seekTac);
			}
		  } catch (e) {
			console.error('Error leyendo de AsyncStorage', e);
		  } finally {
			setLoaded(true);
		  }
		};
	  
		readValue();
	  }, []);

	  const saveData = async () => {
		try {
		  const value = await AsyncStorage.getItem('equipos');
		  const data = value ? JSON.parse(value) : {};
		  data.others = data.others || {};
		  data.others.inmatchStates = data.others.inmatchStates || {};
	
		  data.others.inmatchStates.strategy = {
			chasers: value2,
			beaters: value3,
			changes: value4,
			notUsed: value5,
			beaTacOff: value6,
			beaTacDef: value7,
			keepTac: value8,
			seekTac: value9,
		  };
	
		  await AsyncStorage.setItem('equipos', JSON.stringify(data));
		  console.log("guardado!");
		} catch (e) {
		  console.error('Error guardando en AsyncStorage', e);
		}
	  };
	  
	  useEffect(() => {
		if (!loaded) return;
	  
		saveData();
	  }, [loaded, value2, value3, value4, value5, value6, value7, value8, value9]);
	  

	lang = dr.idiomas[useSelector((state) => state.language)].value

	const templateOptionsStrategies = [
		{label: "Neutra",value: 1},
		{label: "Ofensiva",value: 2},
		{label: "Defensiva",value: 3}
	]
	const templateOptionsStrategies1 = [
		{label: "1-1-1 (Neutra)",value: 1},
		{label: "1-2 (Ofensiva)",value: 2},
		{label: "2-1 (Defensiva)",value: 3}
	]
	const templateOptionsStrategies2 = [
		{label: "1-1 (Neutra)",value: 1},
		{label: "0-2 (Ofensiva)",value: 2},
		{label: "2-0 (Defensiva)",value: 3}
	]
	const offensiveTacticsChasers = [
		{label: "Normales (70 - 30)",value: 1},
		{label: "Equitativos (50 - 50)",value: 2},
		{label: "Mantener en pista (90 - 10)",value: 3},
	]
	const defensiveTacticsChasers = [
		{label: "Ritmo normal",value: 1},
		{label: "Ritmo lento",value: 2},
		{label: "Ritmo rápido",value: 3},
	]
	const offensiveTacticsBeaters = [
		{label: "Estandar (Neutra, adaptarse al rival)",value: 1},
		{label: "Atacar a los delanteros",value: 2},
		{label: "Atacar a los defensores",value: 3}
	]
	const defensiveTacticsBeaters = [
		{label: "Estandar (Neutra, adaptarse al rival)",value: 1},
		{label: "Lanzar Bludger con fuerza",value: 2},
		{label: "Lanzar Bludger con precisión",value: 3}
	]
	const keeperTactics = [
		{label: "Equilibrada (Neutra)",value: 1},
		{label: "Linea defensiva adelantada (subir y apoyar en el ataque)",value: 2},
		{label: "Cierre con llave (quedarse siempre en su área)",value: 3}
	]
	const seekerTactics = [
		{label: "Ir a su bola (Neutra)",value: 1},
		{label: "Distraer al Buscador contrario",value: 2},
		{label: "Centrarse siempre en la Snitch",value: 3}
	]

	const [open2, setOpen2] = useState(false);
	const [value2, setValue2] = useState(null);
	const [items2, setItems2] = useState(templateOptionsStrategies1);
	const [selectedIndex2, setSelectedIndex2] = useState(null);
	const [open3, setOpen3] = useState(false);
	const [value3, setValue3] = useState(null);
	const [items3, setItems3] = useState(templateOptionsStrategies2);
	const [selectedIndex3, setSelectedIndex3] = useState(null);
	const [open4, setOpen4] = useState(false);
	const [value4, setValue4] = useState(null);
	const [items4, setItems4] = useState(offensiveTacticsChasers);
	const [selectedIndex4, setSelectedIndex4] = useState(null);
	const [open5, setOpen5] = useState(false);
	const [value5, setValue5] = useState(null);
	const [items5, setItems5] = useState(defensiveTacticsChasers);
	const [selectedIndex5, setSelectedIndex5] = useState(null);
	const [open6, setOpen6] = useState(false);
	const [value6, setValue6] = useState(null);
	const [items6, setItems6] = useState(offensiveTacticsBeaters);
	const [selectedIndex6, setSelectedIndex6] = useState(null);
	const [open7, setOpen7] = useState(false);
	const [value7, setValue7] = useState(null);
	const [items7, setItems7] = useState(defensiveTacticsBeaters);
	const [selectedIndex7, setSelectedIndex7] = useState(null);
	const [open8, setOpen8] = useState(false);
	const [value8, setValue8] = useState(null);
	const [items8, setItems8] = useState(keeperTactics);
	const [selectedIndex8, setSelectedIndex8] = useState(null);
	const [open9, setOpen9] = useState(false);
	const [value9, setValue9] = useState(null);
	const [items9, setItems9] = useState(seekerTactics);
	const [selectedIndex9, setSelectedIndex9] = useState(null);
	const [open10, setOpen10] = useState(false);
	const [value10, setValue10] = useState(null);
	const [items10, setItems10] = useState(offensiveTacticsChasers);
	const [selectedIndex10, setSelectedIndex10] = useState(null);


	return (
		<View style={{flex:1}}>
			<ImageBackground source={require('./../img/background5.png')} resizeMode="cover" style={{flex:1}}>
				<ScrollView>
					<Text style={[{marginVertical:30},GlobalStyles.textForTitleScreen]}>Estrategias</Text>
					{imageStratFunc()}
					<View style={{ flexDirection: "row", marginHorizontal: 10, marginVertical: 10, justifyContent: 'center', alignItems: 'center', marginBottom:30 }}>
						<View style={{ flex: 1, marginRight: 7, justifyContent: 'center' }}>
							<View>
								<View style={GlobalStyles.centerHorizontally}>
									<Text style={GlobalStyles.textH2}>Cazadores</Text>
								</View>
								<View>
								<DropDownPicker
									open={open2}
									value={value2}
									items={items2}
									setOpen={setOpen2}
									setValue={setValue2}
									setItems={setItems2}
									onSelectItem={(item) => setSelectedIndex2(item.value)}
									placeholder={transl('General.seleccionaJugador', lang)}
									selectedItemContainerStyle={{
										backgroundColor: "#cccccc",
										borderColor: '#ffb3ff'
									}}
									selectedItemLabelStyle={{
										backgroundColor: "#cccccc"
									}}
									style ={{
										borderColor: '#ff80ff',
										borderWidth:3
									}}
									dropDownContainerStyle={{
										borderColor: '#ff80ff',
										borderWidth:3
									}}
									listItemContainerStyle={{
										borderColor: '#ff80ff',
										borderTopWidth:1
									}}
									autoScroll={true}
									listMode="SCROLLVIEW"
								/>
								</View>
							</View>
						</View>
						<View style={{ flex: 1, marginLeft: 7, justifyContent: 'center' }}>
							<View>
								<View style={GlobalStyles.centerHorizontally}>
									<Text style={GlobalStyles.textH2}>Golpeadores</Text>
								</View>
								<DropDownPicker
									open={open3}
									value={value3}
									items={items3}
									setOpen={setOpen3}
									setValue={setValue3}
									setItems={setItems3}
									onSelectItem={(item) => setSelectedIndex3(item.value)}
									placeholder={transl('General.seleccionaJugador', lang)}
									selectedItemContainerStyle={{
										backgroundColor: "#cccccc"
									}}
									selectedItemLabelStyle={{
										backgroundColor: "#cccccc"
									}}
									style ={{
										borderColor: '#80ffff',
										borderWidth:3
									}}
									dropDownContainerStyle={{
										borderColor: '#80ffff',
										borderWidth:3,
									}}
									listItemContainerStyle={{
										borderColor: '#80ffff',
										borderTopWidth:1
									}}
									autoScroll={true}
									listMode="SCROLLVIEW"
								/>
							</View>
						</View>
					</View>
					<View style={{marginTop:100, marginBottom:100}}>
						<View style={{marginBottom:30}}>
							<Text style={GlobalStyles.textForTitleScreen}>Tácticas</Text>
						</View>
						<View style={{marginHorizontal:25,marginBottom:30, zIndex: open4 ? 152 : 102}}>
							<View style={[{marginBottom:5},GlobalStyles.centerHorizontally]}>
								<Text style={GlobalStyles.textH2}>Cambios:</Text>
							</View>
							<View>
								<DropDownPicker
									open={open4} value={value4} items={items4} setOpen={setOpen4} setValue={setValue4} setItems={setItems4}
									onSelectItem={(item) => setSelectedIndex4(item.value)}
									placeholder={"Selecciona una opción"}
									selectedItemContainerStyle={{backgroundColor: "#cccccc"}}
									selectedItemLabelStyle={{
										backgroundColor: "#cccccc"
									}}
									style ={{
										borderColor: '#000000',
										borderWidth: 2
									}}
									dropDownContainerStyle={{
										borderColor: '#000000',
										borderWidth: 2,
									}}
									listMode="SCROLLVIEW"
								/>
							</View>
						</View>
						<View style={{marginHorizontal:25,marginBottom:30, zIndex: open8 ? 151 : 101}}>
							<View style={[{marginBottom:5},GlobalStyles.centerHorizontally]}>
								<Text style={GlobalStyles.textH2}>Tácticas Guardián:</Text>
							</View>
							<View>
								<DropDownPicker
									open={open8} value={value8} items={items8} setOpen={setOpen8} setValue={setValue8} setItems={setItems8}
									onSelectItem={(item) => setSelectedIndex8(item.value)}
									placeholder={"Selecciona una opción"}
									selectedItemContainerStyle={{backgroundColor: "#cccccc"}}
									selectedItemLabelStyle={{
										backgroundColor: "#cccccc"
									}}
									style ={{
										borderColor: '#ffffb3',
										borderWidth: 2,
									}}
									dropDownContainerStyle={{
										borderColor: '#ffffb3',
										borderWidth: 2
									}}
									listMode="SCROLLVIEW"
								/>
							</View>
						</View>
						<View style={{marginHorizontal:25, zIndex: open9 ? 150 : 100}}>
							<View style={[{marginBottom:5},GlobalStyles.centerHorizontally]}>
								<Text style={GlobalStyles.textH2}>Tácticas Buscador:</Text>
							</View>
							<View>
								<DropDownPicker
									open={open9} value={value9} items={items9} setOpen={setOpen9} setValue={setValue9} setItems={setItems9}
									onSelectItem={(item) => setSelectedIndex9(item.value)}
									placeholder={"Selecciona una opción"}
									selectedItemContainerStyle={{backgroundColor: "#cccccc"}}
									selectedItemLabelStyle={{
										backgroundColor: "#cccccc"
									}}
									style ={{
										borderColor: '#ffff66',
										borderWidth: 2
									}}
									dropDownContainerStyle={{
										borderColor: '#ffff66',
										borderWidth: 2
									}}
									listMode="SCROLLVIEW"
								/>
							</View>
						</View>
					</View>
				</ScrollView>
			</ImageBackground>
		</View>
	)
	function imageStratFunc() {
		if (value2 === null || value3 === null) {
			return (
				<Image
					style={{ width: 400, height: 400 * 0.6 }}
					source={require('./../img/loading.gif')}
				/>
			);
		}
	
		const windowsWidth = Dimensions.get('window').width;
		const imageStyle = { width: windowsWidth, height: windowsWidth * 0.6355 };
	
		const imagePaths = {
			'1-1': require('../img/strategies-1-1.png'),
			'1-2': require('../img/strategies-1-2.png'),
			'1-3': require('../img/strategies-1-3.png'),
			'2-1': require('../img/strategies-2-1.png'),
			'2-2': require('../img/strategies-2-2.png'),
			'2-3': require('../img/strategies-2-3.png'),
			'3-1': require('../img/strategies-3-1.png'),
			'3-2': require('../img/strategies-3-2.png'),
			'3-3': require('../img/strategies-3-3.png'),
		};
	
		const imageName = `${value2}-${value3}`;
		const imageStrat = (
			<Image
				style={imageStyle}
				source={imagePaths[imageName]}
			/>
		);

		saveData();
	
		return (
			<View style={{ marginBottom: 'auto', marginTop: 'auto', marginLeft: 'auto', marginRight: 'auto' }}>
				{imageStrat}
			</View>
		);
	}	
}

export default Tactics